import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleQuote20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSpeechBubbleQuote20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.45 15.5V14H3.5a1 1 0 0 1-1-1V5.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-6.22l-.407.32-3.423 2.692zm10.05 0h-5.7l-4.232 3.328a1 1 0 0 1-1.618-.787V15.5H3.5A2.5 2.5 0 0 1 1 13V5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5V13a2.5 2.5 0 0 1-2.5 2.5M8.77 8.434a.75.75 0 0 0-.612-1.369l.305.685-.305-.685h-.002l-.002.002-.005.002-.015.007a3 3 0 0 0-.197.101 4 4 0 0 0-.464.298c-.34.252-.803.677-1.032 1.287a3.25 3.25 0 0 0-.17 1.483 3.7 3.7 0 0 0 .135.662l.005.014.002.006v.002l.001.001h.004l-.003.001.013.036a1.392 1.392 0 1 0 1.45-1.752c.094-.19.272-.375.487-.534a3 3 0 0 1 .385-.237zm4.608 0a.75.75 0 0 0-.613-1.369l.305.685-.305-.685h-.002l-.002.002-.005.002-.015.007a2 2 0 0 0-.197.101 4 4 0 0 0-.464.298c-.34.252-.803.677-1.032 1.287a3.25 3.25 0 0 0-.17 1.483 3.7 3.7 0 0 0 .135.662l.005.014.002.006v.002l.001.001h.004l-.004.001.014.036a1.392 1.392 0 1 0 1.45-1.752c.094-.19.272-.375.487-.534a3 3 0 0 1 .385-.237l.02-.01"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleQuote20);
